/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Member_YesInputs */

const vi_grower_member_yes = /** @type {(inputs: Grower_Member_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có`)
};

/**

* @param {Grower_Member_YesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_member_yes = /** @type {((inputs?: Grower_Member_YesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Member_YesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_member_yes(inputs)
});